export default function test(str) {
    if (str) if (str.length < 2) return "Two characters minimum";
    return true;
}
